import * as React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { Box } from "grid-styled";
import { graphql, compose } from "react-apollo";
import ServiceHistory from "./ServiceHistory";
import { LinkButton } from "../Button";
import NewService from "./NewService";
import JobServicesQuery from "../../queries/JobServices";
import CenteredLoader from "../CenteredLoader";
import join from "../../utils/join-path";

class ServiceHistories extends React.Component {
  renderServicesIndex = passedProps => {
    const { services, match } = this.props;

    if (!services || services.length === 0) {
      return (
        <Box pt={3} style={{ textAlign: "center" }}>
          <p>
            <b>There are no services yet.</b>
          </p>
          <LinkButton
            variant="primary"
            to={{ pathname: join(match.url, "/new"), state: { goBack: true } }}
          >
            Request a service
          </LinkButton>
        </Box>
      );
    } else {
      return (
        <Redirect
          to={join(match.url, `/${services[services.length - 1].id}`)}
        />
      );
    }
  };

  renderCurrentService = props => (
    <ServiceHistory
      baseUrl={this.props.match.url}
      services={this.props.services}
      {...props}
    />
  );

  render() {
    const { loading, match } = this.props;

    if (loading) return <CenteredLoader />;

    return (
      <Box pt={3}>
        <Switch>
          <Route exact path={match.path} render={this.renderServicesIndex} />
          <Route exact path={`${match.path}/new`} component={NewService} />
          <Route
            path={`${match.path}/:serviceId`}
            render={this.renderCurrentService}
          />
        </Switch>
      </Box>
    );
  }
}

const enhance = compose(
  graphql(JobServicesQuery, {
    options: ({ match: { params: { jobId } } }) => ({
      variables: { jobId }
    }),
    props: ({ data: { loading, services } }) => ({
      loading,
      services
    })
  })
);

export default enhance(ServiceHistories);



// WEBPACK FOOTER //
// ./src/components/services/ServiceHistories.js